import React from 'react';

import {
  TpHoverInfo,
  TpHoverRenderContext,
  TpHoverRenderInfo,
  ZoomPanCanvas,
} from '../../zoompan-canvas/ZoomPanCanvas';
import { TpZoomPanelInvPointMapInfo } from '../../zoompan-canvas/zoomPanCanvasHelpers';
import { createDefinition } from './piechart.Renderer';
import { TpChartProps } from '../interfaces';
import { TpRectangleSelection } from '../../zoompan-canvas/helpers';
import { TpEnSelectionFilterTypes } from '../../../../data/selection/interfaces';

export function Piechart({ chartTypeManifest, dataContext, dataBinding, config, widgetContext }: TpChartProps) {
  const widgetGlobalConfig = widgetContext.dashboardContext.widgetGlobalConfig ?? {};
  const {
    definition,
    areaPoints,
    dataTable,
    dataCategories,
    dataItemId,
    pies,
    pieMap,
    colInfoCategories,
    itemCount,
    title,
  } = createDefinition(chartTypeManifest, dataContext, dataBinding, config, widgetGlobalConfig);
  const catCount = pies.length;

  function getHoverInfo(
    mappingInfo: TpZoomPanelInvPointMapInfo,
    logicPositX: number,
    logicPositY: number,
    renderPositX: number,
    renderPositY: number,
  ): TpHoverInfo | null {
    if (mappingInfo.area?.id != 'chart') return null;
    // Use render coordinates as the aspect ratio is not square
    let angle = Math.atan2(renderPositX - mappingInfo.mapX.map(0.5), mappingInfo.mapY.map(0.5) - renderPositY);
    if (angle < 0) angle += 2 * Math.PI;
    for (const pie of pies) {
      if (pie.startAngle <= angle && pie.startAngle + pie.angle >= angle) {
        return {
          dataTableId: dataBinding.dataTableId,
          catColumnId: colInfoCategories.id,
          itemId: pie.value,
        };
      }
    }
    return null;
  }

  function getHoverRenderInfo(hoverInfo: TpHoverInfo, context: TpHoverRenderContext): TpHoverRenderInfo | null {
    if (hoverInfo.dataTableId != dataBinding.dataTableId || hoverInfo.catColumnId != colInfoCategories.id) return null;

    const pie = pieMap[hoverInfo.itemId];
    if (!pie) return null;
    const labels: string[] = [];
    if (context.isActiveChart) {
      labels.push(pie.displayString);
      labels.push(`Count: ${pie.count} (${((pie.count / itemCount) * 100).toFixed(2)}%)`);
    }
    return {
      area: areaPoints,
      logicPosX: null, //0.5 + 0.25 * Math.sin(pie.startAngle + pie.angle / 2),
      logicPosY: null, //0.5 + 0.25 * Math.cos(pie.startAngle + pie.angle / 2),
      labels,
    };
  }

  function onRectangleSelection(rectangleSelection: TpRectangleSelection) {}

  function onItemClicked(selectedCategoryId: string) {
    widgetContext.handleUserSelectionAction({
      type: TpEnSelectionFilterTypes.CATEGORICAL,
      dataTableId: dataTable.id,
      colId: colInfoCategories.id,
      selectedCategoryId,
    });
  }

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <ZoomPanCanvas
        definition={definition}
        getHoverInfo={getHoverInfo}
        getHoverRenderInfo={getHoverRenderInfo}
        onRectangleSelection={onRectangleSelection}
        onItemClicked={onItemClicked}
        maxZoomXAbsolute={catCount * 20}
        maxZoomYRelative={30}
        widgetContext={widgetContext}
        chartTitleInfo={{
          assetId: dataContext.assetId,
          dataType: chartTypeManifest.id,
          title,
        }}
      />
    </div>
  );
}
